module.exports = __webpack_public_path__ + "img/app-ks.35f0f5a4.webp";